import { addEditRequestType } from "../../models";

export const addEditRequestFormData = (
  files: File[],
  request: addEditRequestType,
  removedFileIds: string[] = []
) => {
  const formData = new FormData();

  request.name && formData.append("name", request.name);
  formData.append("client", request.client);
  formData.append("IDNumber", request.IDNumber);
  formData.append("address", request.address);
  formData.append("phoneNumber", request.phoneNumber);
  request.scopeOfCoverage &&
    formData.append("scopeOfCoverage", request.scopeOfCoverage);
  request.note && formData.append("note", request.note);
  files.forEach((file) => formData.append("files", file));
  removedFileIds.forEach((id) => formData.append("removedFileIds", id));

  return formData;
};
